import { FormattedMessage } from 'react-intl';
import { PoolTooltip } from '@synergy/components-next';
import { ReactElement } from 'react';
import { TooltipProps } from '@mui/material';

export const FavoriteToolTip = (props: Omit<TooltipProps, 'title'>): ReactElement => {
    return (
        <PoolTooltip {...props} title={<FormattedMessage id="app.article.favorite.add" />}>
            {props.children}
        </PoolTooltip>
    );
};
